import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip as ToolkitTooltip } from '@quantum-ecosystem/ui-toolkit';

export const FormTooltip = ({
	label,
	content,
	children,
	className,
	placement, // Mantine prop, destructured out
	position, // Mantine prop, destructured out
	withArrow, // Mantine prop, destructured out
	opened, // Mantine prop, destructured out
	...restProps
}) => {
	const tooltipContent = content ?? label;

	if (!tooltipContent) {
		return children;
	}

	return (
		<ToolkitTooltip
			content={tooltipContent}
			className={className}
			{...restProps}
		>
			{children}
		</ToolkitTooltip>
	);
};

FormTooltip.propTypes = {
	label: PropTypes.node,
	content: PropTypes.node,
	children: PropTypes.node,
	className: PropTypes.string,
	placement: PropTypes.string,
	position: PropTypes.string,
	withArrow: PropTypes.bool,
	opened: PropTypes.bool,
};

export default FormTooltip;
